import {useEffect, useState} from "react";
import associateServices from "../../../services";
import Level1 from "./level1";
import Level2 from "./level2";
import Level3 from "./level3";
import Level4 from "./level4";
import {useTranslation} from "react-i18next";
import SvgIcon from "../../../components/svg-icon";

const VerifySettings = () => {

    const {t} = useTranslation()
    const [initial, setInitial] = useState({
        name: '',
        surname: '',
        birthday: '',
        country_id: '',
        residental: '',
        city: '',
        postal_code: '',
        occupation: '',
        verification_level: '',
    })


    useEffect(() => {
        reFetch()
    }, [])

    const [verificationLevel, setVerificationLevel] = useState(0)
    const reFetch = () => {

        const handleApiResponse = (res) => {
            setInitial(res?.data)
            setVerificationLevel(res?.data?.verification_level)
        }
        associateServices.profile({}).then(handleApiResponse)
    }


    console.log('verificationLevel = ', verificationLevel)
    return (
        <div
            className="tab-pane fade show active"
            id="tab-7"
            role="tabpanel"
            aria-labelledby="7-tab"
            tabIndex={0}
        >
            <h3 className="settings__title">
                {t('settings.verify.title')}
            </h3>

            <div className="accordion-benefits" id="accordion-benefits">
                <div className="accordion-benefits__card no-border accordion-benefits__card--bronze">
                    <button
                        className="accordion-head background collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapse1-benefits"
                        aria-expanded="false"
                        aria-controls="collapse1-benefits"
                        disabled={verificationLevel > 1}
                    >

                        <span className="settings__level">
                               {verificationLevel > 1 ? t('general.completed') : t('settings.verify.level1.title')}
                        </span>

                        <SvgIcon id={'right-down'}/>
                    </button>
                    <div
                        id="collapse1-benefits"
                        className={`collapse ${verificationLevel === 1 ? 'show' : ''}`}
                        data-bs-parent="#accordion-benefits"
                    >
                        <Level1
                            reFetch={reFetch}
                            initial={initial}/>

                    </div>
                </div>
                <div className="accordion-benefits__card no-border accordion-benefits__card--silver">
                    <button
                        className="accordion-head background collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapse2-benefits"
                        aria-expanded="false"
                        aria-controls="collapse2-benefits"
                        disabled={verificationLevel !== 2}

                    >

                        <span className="settings__level">
                               {verificationLevel > 2 ? t('general.completed') : t('settings.verify.level2.title')}
                        </span>

                        <SvgIcon id={'right-down'}/>
                    </button>
                    <div
                        id="collapse2-benefits"
                        className={`collapse ${verificationLevel === 2 ? 'show' : ''}`}

                        data-bs-parent="#accordion-benefits"
                    >
                        <Level2/>
                    </div>
                </div>
                <div className="accordion-benefits__card no-border accordion-benefits__card--gold">
                    <button
                        className="accordion-head background collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapse3-benefits"
                        aria-expanded="false"
                        aria-controls="collapse3-benefits"
                        disabled={verificationLevel !== 3}

                    >
                           <span className="settings__level">
                               {verificationLevel > 3 ? t('general.completed') : t('settings.verify.level3.title')}
                        </span>
                        <SvgIcon id={'right-down'}/>
                    </button>
                    <div
                        id="collapse3-benefits"
                        className={`collapse ${verificationLevel === 3 ? 'show' : ''}`}
                        data-bs-parent="#accordion-benefits"
                    >
                        <Level3/>
                    </div>
                </div>
                <div className="accordion-benefits__card no-border accordion-benefits__card--rose">
                    <button
                        className="accordion-head background collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapse4-benefits"
                        aria-expanded="false"
                        aria-controls="collapse4-benefits"
                        disabled={verificationLevel !== 4}
                    >


                        <span className="settings__level">
                               {verificationLevel > 4 ? t('general.completed') : t('settings.verify.level4.title')}
                        </span>
                        <SvgIcon id={'right-down'}/>
                    </button>

                    <div
                        id="collapse4-benefits"
                        className={`collapse ${verificationLevel === 4 ? 'show' : ''}`}
                        data-bs-parent="#accordion-benefits"
                    >
                        <Level4/>

                    </div>
                </div>
            </div>


        </div>
    )

}


export default VerifySettings
